/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export const rollerDimensions = {
  Big: { width: 150, height: 30 },
  Mid: { width: 100, height: 20 },
  Small: { width: 60, height: 15 }
};
export function sprayWithRoller(x, y, { state, canvas, notifications }) {
  const ctx = canvas.activeCtx;
  const config = state.config;
  const cansData = state.cansData;
  const presetConfig = state.presetConfig || {};
  const enableDrips = state.enableDrips;
  const paintConsumption = state.paintConsumption || 1;
  const activeCan = cansData.find(c => c.id === config.activeCanId);
  if (!activeCan || activeCan.paintLeft <= 0) {
    notifications.showPaintEmptyToast(config.activeCanId);
    return;
  }
  const now = performance.now();
  let speed = 0;
  if (state.lastSprayPos && state.lastSprayTime !== null) {
    const dt = now - state.lastSprayTime;
    const dist = Math.hypot(x - state.lastSprayPos.x, y - state.lastSprayPos.y);
    speed = Math.min(1, dist / (dt || 1) / config.speedFactor);
  }
  let currentPresetKey = state.currentPreset || 'Big';
  if (currentPresetKey === 'BIG Roller') currentPresetKey = 'Big';
  else if (currentPresetKey === 'MID Roller') currentPresetKey = 'Mid';
  else if (currentPresetKey === 'SMALL Roller') currentPresetKey = 'Small';
  const defaultDims = rollerDimensions[currentPresetKey] || rollerDimensions.Big;
  const rollerWidth = presetConfig.rollerWidth || defaultDims.width;
  const rollerHeight = presetConfig.rollerHeight || defaultDims.height;
  ctx.fillStyle = config.currentColor;
  ctx.globalAlpha = 0.25;
  ctx.fillRect(
    x - rollerWidth / 2,
    y - rollerHeight / 2,
    rollerWidth,
    rollerHeight
  );
  let paintUsedCount = 0;
  try {
    const startX = Math.round(x - rollerWidth / 2);
    const startY = Math.round(y - rollerHeight / 2);
    for (let sx = 0; sx < 3; sx++) {
      for (let sy = 0; sy < 3; sy++) {
        const px = startX + Math.round((sx / 2) * Math.max(0, rollerWidth - 1));
        const py = startY + Math.round((sy / 2) * Math.max(0, rollerHeight - 1));
        const key = px + '_' + py;
        if (!state.paintedPixels.has(key)) {
          state.paintedPixels.add(key);
          paintUsedCount++;
        }
      }
    }
  } catch (e) {
  }
  const blurRadius = 1;
  const pointsToDraw = Math.min(config.dotsPerTick, 500);
  for (let i = 0; i < pointsToDraw; i++) {
    const offsetX = (Math.random() - 0.5) * (rollerWidth + blurRadius * 2);
    const offsetY = (Math.random() - 0.5) * (rollerHeight + blurRadius * 2);
    if (Math.abs(offsetX) < rollerWidth / 2 + blurRadius &&
      Math.abs(offsetY) < rollerHeight / 2 + blurRadius) {
      const distanceFromEdgeX = Math.max(0, Math.abs(offsetX) - rollerWidth / 2);
      const distanceFromEdgeY = Math.max(0, Math.abs(offsetY) - rollerHeight / 2);
      const edgeDistance = Math.sqrt(distanceFromEdgeX * distanceFromEdgeX +
        distanceFromEdgeY * distanceFromEdgeY);
      ctx.globalAlpha = 0.3 * (1 - Math.min(1, edgeDistance / blurRadius));
      ctx.fillStyle = config.currentColor;
      ctx.beginPath();
      ctx.arc(x + offsetX, y + offsetY, 1 + Math.random() * 2, 0, 2 * Math.PI);
      ctx.fill();
      const px = Math.round(x + offsetX);
      const py = Math.round(y + offsetY);
      const key = px + '_' + py;
      if (!state.paintedPixels.has(key)) {
        state.paintedPixels.add(key);
        paintUsedCount++;
      }
    }
  }
  const timeHeld = (function () {
    if (!state.lastStaticSprayPos) {
      state.lastStaticSprayPos = { x, y };
      state.staticSprayStartTime = Date.now();
      state.isStaticSpraying = true;
      return false;
    }
    const distance = Math.hypot(x - state.lastStaticSprayPos.x, y - state.lastStaticSprayPos.y);
    const threshold = 5;
    if (distance > threshold) {
      state.lastStaticSprayPos = { x, y };
      state.staticSprayStartTime = Date.now();
      state.isStaticSpraying = false;
      return false;
    }
    const t = Date.now() - state.staticSprayStartTime;
    if (t > 100) {
      state.isStaticSpraying = true;
      return t;
    }
    state.isStaticSpraying = false;
    return false;
  })();
  if (timeHeld && enableDrips) {
    const dripChance = presetConfig.dripChance || 0.02;
    if (Math.random() < dripChance) {
      ctx.save();
      ctx.globalAlpha = presetConfig.dripAlpha || 0.08;
      ctx.strokeStyle = config.currentColor;
      ctx.lineWidth = 3 + Math.random() * 4;
      ctx.beginPath();
      ctx.moveTo(x + (Math.random() * 4 - 2), y + rollerHeight / 2);
      const dripLength = (presetConfig.dripLength || 15) * (1 + timeHeld / 5000);
      ctx.lineTo(x + (Math.random() * 8 - 4), y + rollerHeight / 2 + dripLength);
      ctx.stroke();
      ctx.restore();
    }
  }
  if (paintUsedCount > 0) {
    const canvasEl = canvas.canvas;
    const totalPixels = (canvasEl && canvasEl.width && canvasEl.height) ? (canvasEl.width * canvasEl.height) : 1;
    const pixelsPerCan = state.pixelsPerCan || Math.max(1, Math.floor(totalPixels * 4));
    const paintUnitsPerPixel = state.config.paintMax / pixelsPerCan;
    const totalPaintUsed = Math.max(1, Math.round(paintUsedCount * paintUnitsPerPixel * (state.paintConsumption || 1)));
    state.updateCanPaint(state.config.activeCanId, totalPaintUsed);
  }
  state.lastSprayPos = { x, y };
  state.lastSprayTime = now;
  ctx.globalAlpha = 1;
}